/* ============================================================
   MODULO — PROMO POPUP
   Scratch-to-win email-capture modal. One controller per
   [data-modulo-pp] section. Triggers are armed immediately
   (NOT lazy/in-view) because the modal is fixed-position.
   ============================================================ */
(function () {
  "use strict";
  if (typeof window === "undefined" || typeof document === "undefined") return;

  var REDUCED = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var THRESHOLD = 0.55; // fraction cleared → reveal
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  /* ---- shared, instance-counted body scroll-lock ---- */
  var lockCount = 0, savedY = 0;
  function lockScroll() {
    if (lockCount++ === 0) {
      savedY = window.scrollY || window.pageYOffset || 0;
      document.body.style.top = -savedY + "px";
      document.body.classList.add("modulo-pp--locked");
    }
  }
  function unlockScroll() {
    if (lockCount > 0 && --lockCount === 0) {
      document.body.classList.remove("modulo-pp--locked");
      document.body.style.top = "";
      window.scrollTo(0, savedY);
    }
  }

  /* ============================================================
     SCRATCH ENGINE
     ============================================================ */
  function makeScratch(root) {
    var scratch = root.querySelector("[data-pp-scratch]");
    var canvas = root.querySelector("[data-pp-canvas]");
    if (!scratch || !canvas) return null;

    var sparkBox = root.querySelector("[data-pp-spark]");
    var fill = root.querySelector("[data-pp-fill]");
    var pctEl = root.querySelector("[data-pp-pct]");
    var stateEl = root.querySelector("[data-pp-state]");
    var statusEl = root.querySelector("[data-pp-prize-status]");
    var kickerEl = root.querySelector("[data-pp-prize-kicker]");
    var bigEl = root.querySelector("[data-pp-prize-big]");
    var smallEl = root.querySelector("[data-pp-prize-small]");
    var revealBtn = root.querySelector("[data-pp-reveal]");

    var ctx = canvas.getContext("2d");
    var revealed = false, drawing = false, lastP = null;
    var dpr = Math.max(1, Math.min(window.devicePixelRatio || 1, 2));
    var rafPending = false;
    var erasedPx = 0, areaPx = 1;

    function paintFoil() {
      var rect = canvas.getBoundingClientRect();
      if (rect.width === 0) return;
      dpr = Math.max(1, Math.min(window.devicePixelRatio || 1, 2));
      canvas.width = Math.round(rect.width * dpr);
      canvas.height = Math.round(rect.height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var w = rect.width, h = rect.height;
      areaPx = Math.max(1, w * h);
      erasedPx = 0;

      ctx.globalCompositeOperation = "source-over";
      ctx.clearRect(0, 0, w, h);

      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, "#E2C57E"); g.addColorStop(0.28, "#D8B968");
      g.addColorStop(0.5, "#F0DDA0"); g.addColorStop(0.72, "#B68A33");
      g.addColorStop(1, "#D8B968");
      ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);

      ctx.globalAlpha = 0.18;
      for (var i = -h; i < w; i += 9) {
        ctx.strokeStyle = (i % 18 === 0) ? "#F6E7B4" : "#9A741F";
        ctx.lineWidth = 2.2;
        ctx.beginPath(); ctx.moveTo(i, 0); ctx.lineTo(i + h, h); ctx.stroke();
      }
      ctx.globalAlpha = 0.10;
      var grains = Math.round((w * h) / 240);
      for (var s = 0; s < grains; s++) {
        ctx.fillStyle = ((s * 7 + 3) % 11 > 5) ? "#5E4612" : "#FBEFC4";
        ctx.fillRect(((s * 53) % w), ((s * 97) % h), 1.4, 1.4);
      }
      ctx.globalAlpha = 1;

      var hg = ctx.createLinearGradient(0, 0, 0, h);
      hg.addColorStop(0, "rgba(255,255,255,.28)"); hg.addColorStop(0.18, "rgba(255,255,255,0)");
      ctx.fillStyle = hg; ctx.fillRect(0, 0, w, h);

      var vg = ctx.createRadialGradient(w / 2, h / 2, h * 0.2, w / 2, h / 2, w * 0.62);
      vg.addColorStop(0, "rgba(0,0,0,0)"); vg.addColorStop(1, "rgba(74,55,14,.24)");
      ctx.fillStyle = vg; ctx.fillRect(0, 0, w, h);

      ctx.strokeStyle = "rgba(122,90,20,.55)"; ctx.lineWidth = 1.5;
      ctx.strokeRect(0.75, 0.75, w - 1.5, h - 1.5);

      ctx.globalCompositeOperation = "destination-out";
    }

    function pointFromEvent(e) {
      var rect = canvas.getBoundingClientRect();
      var cx = e.touches ? e.touches[0].clientX : e.clientX;
      var cy = e.touches ? e.touches[0].clientY : e.clientY;
      return {
        x: (cx - rect.left) * (canvas.width / rect.width) / dpr,
        y: (cy - rect.top) * (canvas.height / rect.height) / dpr
      };
    }

    function eraseAt(x, y) {
      var r = Math.max(18, (canvas.width / dpr) * 0.052);
      var grad = ctx.createRadialGradient(x, y, 0, x, y, r);
      grad.addColorStop(0, "rgba(0,0,0,1)"); grad.addColorStop(0.65, "rgba(0,0,0,1)"); grad.addColorStop(1, "rgba(0,0,0,0)");
      ctx.fillStyle = grad;
      ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill();
      erasedPx += Math.PI * r * r * 0.62;
    }

    function lineScratch(p) {
      if (lastP) {
        var dx = p.x - lastP.x, dy = p.y - lastP.y;
        var steps = Math.ceil(Math.hypot(dx, dy) / 8);
        for (var i = 1; i <= steps; i++) eraseAt(lastP.x + dx * (i / steps), lastP.y + dy * (i / steps));
      }
      eraseAt(p.x, p.y);
      lastP = p;
    }

    function checkProgress() {
      if (rafPending) return; rafPending = true;
      requestAnimationFrame(function () {
        rafPending = false;
        if (revealed) return;
        var pct = Math.min(1, (erasedPx * 0.6) / areaPx);
        var shown = Math.min(100, Math.round(pct * 100));
        if (pctEl) pctEl.textContent = shown + "%";
        if (fill) fill.style.transform = "scaleX(" + shown / 100 + ")";
        if (stateEl) stateEl.textContent = shown === 0 ? "Foil intact" : "Keep scratching…";
        if (pct >= THRESHOLD) doReveal();
      });
    }

    function startScratch(e) {
      if (revealed) return;
      if (REDUCED) { doReveal(); return; }
      drawing = true; scratch.classList.add("is-active"); lastP = null;
      lineScratch(pointFromEvent(e));
      if (e.cancelable) e.preventDefault();
    }
    function moveScratch(e) {
      if (!drawing || revealed) return;
      lineScratch(pointFromEvent(e)); checkProgress();
      if (e.cancelable) e.preventDefault();
    }
    function endScratch() { if (!drawing) return; drawing = false; lastP = null; checkProgress(); }

    canvas.addEventListener("mousedown", startScratch);
    window.addEventListener("mousemove", moveScratch);
    window.addEventListener("mouseup", endScratch);
    canvas.addEventListener("touchstart", startScratch, { passive: false });
    canvas.addEventListener("touchmove", moveScratch, { passive: false });
    window.addEventListener("touchend", endScratch);

    canvas.tabIndex = 0;
    canvas.setAttribute("role", "button");
    canvas.setAttribute("aria-label", "Scratch panel — press Enter to reveal your prize");
    canvas.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); doReveal(); }
    });
    if (revealBtn) revealBtn.addEventListener("click", function () { doReveal(); });

    function announce() {
      if (!statusEl) return;
      var k = kickerEl ? kickerEl.textContent : "You've won";
      var big = bigEl ? bigEl.textContent : "";
      var small = smallEl ? smallEl.textContent : "";
      statusEl.textContent = (k + " " + big + " " + small + ". Enter your email to claim your code.").replace(/\s+/g, " ").trim();
    }

    function clearSparks() { if (sparkBox) while (sparkBox.firstChild) sparkBox.removeChild(sparkBox.firstChild); }

    function confetti() {
      if (!sparkBox) return;
      clearSparks();
      var colors = ["#FF5638", "#CC3A18", "#211C16", "#F0DDA0", "#D8B968"];
      for (var i = 0; i < 26; i++) {
        var sp = document.createElement("span");
        sp.style.background = colors[i % colors.length];
        sp.style.borderRadius = (i % 4 === 0) ? "50%" : "2px";
        sparkBox.appendChild(sp);
        var ang = (i / 26) * Math.PI * 2;
        var dist = 56 + (i % 5) * 22;
        var dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist - 30;
        var rot = (i % 2 ? 1 : -1) * (180 + i * 12);
        sp.animate([
          { transform: "translate(-50%,-50%) translate(0,0) rotate(0)", opacity: 1 },
          { transform: "translate(-50%,-50%) translate(" + dx + "px," + dy + "px) rotate(" + rot + "deg)", opacity: 1, offset: 0.7 },
          { transform: "translate(-50%,-50%) translate(" + dx * 1.12 + "px," + (dy + 70) + "px) rotate(" + rot * 1.2 + "deg)", opacity: 0 }
        ], { duration: 760 + (i % 6) * 90, easing: "cubic-bezier(.18,.7,.3,1)", fill: "forwards" });
      }
      setTimeout(clearSparks, 1500);
    }

    function doReveal() {
      if (revealed) return;
      revealed = true;
      scratch.classList.add("is-revealed");
      if (pctEl) pctEl.textContent = "100%";
      if (fill) fill.style.transform = "scaleX(1)";
      if (stateEl) stateEl.textContent = "Prize revealed";
      announce();
      if (root._onReveal) root._onReveal();
      if (!REDUCED && sparkBox && typeof sparkBox.animate !== "undefined") confetti();
    }

    function reset() {
      revealed = false; drawing = false; lastP = null; erasedPx = 0;
      scratch.classList.remove("is-revealed", "is-active");
      clearSparks();
      if (pctEl) pctEl.textContent = "0%";
      if (fill) fill.style.transform = "scaleX(0)";
      if (stateEl) stateEl.textContent = "Foil intact";
      if (statusEl) statusEl.textContent = "";
      if (REDUCED) { doReveal(); return; }
      paintFoil();
    }

    var ro = window.ResizeObserver ? new ResizeObserver(function () { if (!revealed && !drawing) paintFoil(); }) : null;
    if (ro) ro.observe(canvas);

    if (REDUCED) requestAnimationFrame(doReveal);
    else { requestAnimationFrame(paintFoil); setTimeout(paintFoil, 60); }

    return { reset: reset, reveal: doReveal, repaint: function () { if (!revealed) paintFoil(); }, isRevealed: function () { return revealed; } };
  }

  /* ============================================================
     FORM ENGINE — validate + AJAX submit + reveal code
     ============================================================ */
  function makeForm(root, getScratch) {
    var wrap = root.querySelector("[data-pp-formwrap]");
    if (!wrap) return null;
    var form = wrap.querySelector("form");
    if (!form) return null;
    var email = wrap.querySelector("[data-pp-email]");
    var errEl = wrap.querySelector("[data-pp-err]");
    var codeEl = wrap.querySelector("[data-pp-code]");
    var copyBtn = wrap.querySelector("[data-pp-copy]");
    var copyLbl = wrap.querySelector("[data-pp-copylabel]");
    var claim = wrap.querySelector("[data-pp-claim]");
    var honeypot = wrap.querySelector("[data-pp-hp]");
    var claimText = claim ? claim.textContent : "Claim";
    var copyText = copyLbl ? copyLbl.textContent : "Copy";

    function showError(kind) {
      if (errEl) {
        errEl.textContent = kind === "empty" ? "Enter your email to reveal the code." : "That email looks incomplete — check for a typo.";
        errEl.classList.add("show");
      }
      if (email) email.setAttribute("aria-invalid", "true");
    }
    function clearError() {
      if (email) email.removeAttribute("aria-invalid");
      if (errEl) errEl.classList.remove("show");
    }

    function settle() {
      if (claim) { claim.removeAttribute("aria-busy"); claim.textContent = "Claimed ✓"; claim.style.opacity = ".55"; claim.disabled = true; }
      if (email) email.disabled = true;
      wrap.classList.add("is-done");
      if (codeEl) codeEl.classList.add("show");
      var sc = getScratch && getScratch();
      if (sc && !sc.isRevealed()) sc.reveal();
      var applyEl = wrap.querySelector("[data-pp-apply]");
      var move = applyEl || copyBtn;
      setTimeout(function () { if (move) try { move.focus({ preventScroll: true }); } catch (_) { move.focus(); } }, 120);
    }

    form.addEventListener("submit", function (e) {
      if (form.dataset.ppDone === "1") { e.preventDefault(); return; }
      if (honeypot && honeypot.value) { e.preventDefault(); return; }
      var v = (email && email.value || "").trim();
      if (!v) { e.preventDefault(); showError("empty"); if (email) email.focus(); return; }
      if (!EMAIL_RE.test(v)) { e.preventDefault(); showError("invalid"); email.focus(); return; }
      clearError();
      // no fetch/FormData support → let the native form POST + reload (posted_successfully reveals the code)
      if (!window.fetch || !window.FormData) { form.dataset.ppDone = "1"; return; }
      e.preventDefault();
      form.dataset.ppDone = "1";
      if (claim) { claim.disabled = true; claim.setAttribute("aria-busy", "true"); claim.textContent = "Revealing…"; }
      var action = form.getAttribute("action") || window.location.pathname;
      var done = false;
      var finish = function () { if (done) return; done = true; if (REDUCED) settle(); else setTimeout(settle, 360); };
      // native submit doesn't fire this handler again (form.submit() skips the submit event),
      // so it's a safe last resort: the POST still happens and posted_successfully? reveals the code
      var native = function () { try { form.submit(); } catch (_) { settle(); } };
      fetch(action, { method: "POST", body: new FormData(form), headers: { "Accept": "text/html" }, credentials: "same-origin" })
        .then(function (r) {
          // fetch does NOT reject on 4xx/5xx — without this gate a rejected signup
          // still revealed the discount code, i.e. a code handed out for an email we never captured
          if (!r || !r.ok) { native(); return; }
          finish();
        }, native); // hard network failure → native submit guarantees capture
    });

    if (email) {
      email.addEventListener("input", function () {
        if (email.getAttribute("aria-invalid") === "true" && EMAIL_RE.test(email.value.trim())) clearError();
      });
      email.addEventListener("blur", function () {
        var v = (email.value || "").trim();
        if (v && !EMAIL_RE.test(v)) showError("invalid");
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener("click", function () {
        var code = copyBtn.getAttribute("data-code") || "";
        var notify = function () {
          copyBtn.classList.add("is-copied");
          if (copyLbl) copyLbl.textContent = "Copied ✓";
          setTimeout(function () { copyBtn.classList.remove("is-copied"); if (copyLbl) copyLbl.textContent = copyText; }, 1900);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(notify, fallback);
        } else fallback();
        function fallback() {
          var t = document.createElement("textarea");
          t.value = code; t.style.position = "fixed"; t.style.opacity = "0";
          document.body.appendChild(t); t.select();
          try { document.execCommand("copy"); } catch (_) { }
          t.remove(); notify();
        }
      });
    }

    return {
      markDone: function () { form.dataset.ppDone = "1"; wrap.classList.add("is-done"); if (codeEl) codeEl.classList.add("show"); },
      reset: function () {
        form.dataset.ppDone = "";
        wrap.classList.remove("is-done");
        if (codeEl) codeEl.classList.remove("show");
        if (errEl) errEl.classList.remove("show");
        if (honeypot) honeypot.value = "";
        if (email) { email.value = ""; email.disabled = false; email.removeAttribute("aria-invalid"); }
        if (claim) { claim.disabled = false; claim.removeAttribute("aria-busy"); claim.textContent = claimText; claim.style.opacity = ""; }
        if (copyLbl) copyLbl.textContent = copyText;
      }
    };
  }

  /* ============================================================
     POPUP CONTROLLER — open/close, focus trap, ESC, scroll-lock
     ============================================================ */
  function wirePopup(sectionEl) {
    var scrim = sectionEl.querySelector("[data-pp-scrim]");
    if (!scrim) return null;
    var dialog = scrim.querySelector("[data-pp-dialog]");
    var closeEls = scrim.querySelectorAll("[data-pp-close]");
    var launcher = sectionEl.querySelector("[data-pp-launcher]");
    var lastFocus = null, isOpen = false;

    var titleEl = scrim.querySelector("[data-pp-title]");
    var subEl = scrim.querySelector("[data-pp-sub]");
    var uid = "pp-" + (sectionEl.getAttribute("data-section-id") || Math.random().toString(36).slice(2, 8));
    if (titleEl && dialog) { titleEl.id = uid + "-t"; dialog.setAttribute("aria-labelledby", uid + "-t"); }
    if (subEl && dialog) { subEl.id = uid + "-s"; dialog.setAttribute("aria-describedby", uid + "-s"); }

    var scratchCtl = makeScratch(scrim);
    scrim._scratch = scratchCtl;
    var formCtl = makeForm(scrim, function () { return scratchCtl; });

    // Scroll cue: the content column overflows on short viewports, and with overlay
    // scrollbars there is nothing to say so — the clipped last line looks like a bug.
    var contentEl = scrim.querySelector(".modulo-pp__content");
    if (contentEl) {
      var syncCue = function () {
        var remaining = contentEl.scrollHeight - contentEl.clientHeight - contentEl.scrollTop;
        contentEl.classList.toggle("has-more", remaining > 4);
      };
      contentEl.addEventListener("scroll", syncCue, { passive: true });
      // ResizeObserver covers open (0 → measurable), viewport resize and reveal-time growth
      if (window.ResizeObserver) { try { new ResizeObserver(syncCue).observe(contentEl); } catch (_) { } }
      window.addEventListener("resize", syncCue);
      syncCue();
    }

    var formWrap = scrim.querySelector("[data-pp-formwrap]");
    var locks = formWrap && formWrap.hasAttribute("data-pp-lockform") && scratchCtl && !REDUCED;
    if (locks) formWrap.classList.add("is-locked");
    scrim._onReveal = function () { if (formWrap) formWrap.classList.remove("is-locked"); };

    function focusables() {
      return Array.prototype.slice.call(dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), canvas[tabindex], [tabindex]:not([tabindex="-1"])'
      )).filter(function (el) { return el.offsetParent !== null; });
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      lastFocus = document.activeElement;
      scrim.hidden = false;
      scrim.classList.remove("is-closing");
      lockScroll();
      if (launcher) launcher.classList.remove("show");
      dialog.style.animation = "none"; void dialog.offsetWidth; dialog.style.animation = "";
      requestAnimationFrame(function () {
        if (scratchCtl) scratchCtl.repaint();
        // focus the close (NOT the email) so mobile keyboards never shove the sheet
        var first = scrim.querySelector("[data-pp-close]");
        if (first) try { first.focus({ preventScroll: true }); } catch (_) { first.focus(); }
      });
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      unlockScroll();
      var done = function () {
        scrim.hidden = true;
        scrim.classList.remove("is-closing");
        if (launcher) launcher.classList.add("show");
        if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (_) { }
      };
      if (REDUCED) { done(); return; }
      scrim.classList.add("is-closing");
      var fired = false;
      var fin = function () { if (fired) return; fired = true; scrim.removeEventListener("transitionend", fin); done(); };
      scrim.addEventListener("transitionend", fin);
      setTimeout(fin, 480);
    }

    for (var i = 0; i < closeEls.length; i++) closeEls[i].addEventListener("click", close);

    var downOnScrim = false;
    scrim.addEventListener("mousedown", function (e) { downOnScrim = e.target === scrim; });
    scrim.addEventListener("mouseup", function (e) { if (downOnScrim && e.target === scrim) close(); downOnScrim = false; });

    scrim.addEventListener("keydown", function (e) {
      if (scrim.hidden) return;
      if (e.key === "Escape") { e.preventDefault(); close(); return; }
      if (e.key === "Tab") {
        var f = focusables(); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    if (launcher) launcher.addEventListener("click", open);

    return {
      open: open, close: close, scratch: scratchCtl, form: formCtl, launcher: launcher,
      showLauncher: function () { if (launcher) launcher.classList.add("show"); }
    };
  }

  /* ============================================================
     TRIGGERS + FREQUENCY CAP
     ============================================================ */
  function storeKey(sectionEl) { return "modulo-pp-" + (sectionEl.getAttribute("data-section-id") || "x"); }

  function suppressed(sectionEl) {
    var days = parseInt(sectionEl.getAttribute("data-frequency"), 10) || 0;
    if (days <= 0) return false;
    try {
      var ts = parseInt(window.localStorage.getItem(storeKey(sectionEl)), 10);
      if (!ts) return false;
      return (Date.now() - ts) < days * 86400000;
    } catch (_) { return false; }
  }
  function stamp(sectionEl) {
    try { window.localStorage.setItem(storeKey(sectionEl), String(Date.now())); } catch (_) { }
  }

  function initSection(sectionEl) {
    if (sectionEl._ppInit) return;
    sectionEl._ppInit = true;
    var ctl = wirePopup(sectionEl);
    if (!ctl) return;

    var posted = !!sectionEl.querySelector("[data-pp-posted]");
    var opened = false;
    function openOnce() {
      if (opened) return; opened = true;
      stamp(sectionEl);
      ctl.open();
    }

    // returning from a no-JS native submit: show the revealed code straight away
    if (posted) {
      if (ctl.form) ctl.form.markDone();
      if (ctl.scratch) ctl.scratch.reveal();
      openOnce();
      return;
    }

    // theme editor: always preview, ignore the frequency cap
    if (DESIGN) { ctl.open(); ctl.showLauncher(); return; }

    if (suppressed(sectionEl)) { ctl.showLauncher(); return; }

    var trigger = sectionEl.getAttribute("data-trigger") || "delay";

    if (trigger === "button") {
      ctl.showLauncher();
      return;
    }
    if (trigger === "page_load") { openOnce(); return; }

    if (trigger === "delay") {
      var secs = parseInt(sectionEl.getAttribute("data-delay"), 10);
      if (isNaN(secs)) secs = 4;
      setTimeout(openOnce, secs * 1000);
      ctl.showLauncher();
      return;
    }

    if (trigger === "scroll") {
      var pct = parseInt(sectionEl.getAttribute("data-scroll"), 10) || 35;
      var onScroll = function () {
        var docH = document.documentElement.scrollHeight - window.innerHeight;
        var reached = docH <= 0 ? 100 : ((window.scrollY || window.pageYOffset) / docH) * 100;
        if (reached >= pct) { window.removeEventListener("scroll", onScroll); openOnce(); }
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      ctl.showLauncher();
      return;
    }

    if (trigger === "exit") {
      var onOut = function (e) {
        if (e.clientY <= 0 && !e.relatedTarget && !e.toElement) {
          document.removeEventListener("mouseout", onOut);
          openOnce();
        }
      };
      document.addEventListener("mouseout", onOut);
      ctl.showLauncher();
      return;
    }

    ctl.showLauncher();
  }

  function boot() {
    var els = document.querySelectorAll("[data-modulo-pp]");
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  // re-init when a merchant adds/edits the section in the theme editor
  if (DESIGN) {
    document.addEventListener("shopify:section:load", function (e) {
      var el = e.target && e.target.querySelector ? e.target.querySelector("[data-modulo-pp]") : null;
      if (el) initSection(el);
    });
  }
})();
